module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal payment dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Payment Link")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-lighter",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "w-100 px-4 pt-4 bg-lightest"
  }, [_c('div', {
    staticClass: "d-flex mb-4"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('label', [_vm._v("Amount "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('div', {
    staticClass: "col-sm-3 d-flex justify-content-center"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkValue),
      expression: "linkValue"
    }, {
      name: "numFloat",
      rawName: "v-numFloat"
    }],
    staticClass: "fs-large flex-grow-1 text-right bg-lighter glued-right input--value",
    attrs: {
      "type": "text",
      "placeholder": "0",
      "disabled": _vm.generatedLink[0]
    },
    domProps: {
      "value": (_vm.linkValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "border-light d-flex justify-content-center glued-left fs-large py-2 px-2 currency-symbol"
  }, [_vm._v("€")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex align-items-center"
  }, [(_vm.isValueExceedingDue) ? _c('span', {
    staticClass: "fs-small color-6"
  }, [_vm._v("The payment amount cannot exceed the amount due.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center customazed-v-select"
  }, [_c('label', [_vm._v("Select a time to reservation expires "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeReservationExpires),
      expression: "timeReservationExpires"
    }],
    staticClass: "fs-large flex-grow-1 text-right bg-lighter glued-right",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "type": "number",
      "step": ".01",
      "min": "0",
      "max": "999",
      "placeholder": "0",
      "disabled": _vm.generatedLink[0]
    },
    domProps: {
      "value": (_vm.timeReservationExpires)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.timeReservationExpires = $event.target.value
      }, _vm.validateExpirationInput]
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "border-light d-flex justify-content-center glued-left fs-large",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "options": _vm.optionsTypesTime,
      "label": "description"
    },
    model: {
      value: (_vm.selectedTypeTime),
      callback: function($$v) {
        _vm.selectedTypeTime = $$v
      },
      expression: "selectedTypeTime"
    }
  })], 1)]), _vm._v(" "), (_vm.isExpirationExceedingLimit) ? _c('div', {
    staticClass: "fs-small color-6 mt-2"
  }, [_vm._v("\n                    Maximum value is 999. Hours: up to 999 hours (~41 days), Days: up to 999 days (~2.7 years).\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex align-items-end mb-2 justify-content-end"
  }, [_c('div', [_c('label', {
    staticClass: "mr-3"
  }, [(_vm.totalDue >= 0) ? _c('span', [(_vm.reservation.changeStatusTo == '-5' || _vm.reservation.changeStatusTo == '-6') ? _c('span', [_vm._v("Value to refund")]) : _c('span', [_vm._v("Due to Pay")])]) : _vm._e(), _vm._v(" "), (_vm.totalDue < 0) ? _c('span', [_vm._v("Over Pay")]) : _vm._e()]), _vm._v(" "), (_vm.getReservationCreation) ? _c('span', {
    staticClass: "fs-large font-weight-600 pointer",
    class: {
      'color-3': (_vm.outstandingAmout - _vm.generatedLinkValue) == 0
    },
    on: {
      "click": function($event) {
        return _vm.copyValueToInput(_vm.outstandingAmout - _vm.generatedLinkValue)
      }
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.outstandingAmout - _vm.generatedLinkValue)) + " €")]) : _c('span', {
    staticClass: "fs-large font-weight-600 pointer",
    class: {
      'color-3': (_vm.totalDue - _vm.generatedLinkValue) == 0
    },
    on: {
      "click": function($event) {
        return _vm.copyValueToInput(_vm.totalDue - _vm.generatedLinkValue)
      }
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalDue - _vm.generatedLinkValue)) + " €")]), _vm._v(" "), _c('label', {
    staticClass: "mx-3"
  }, [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600 pointer",
    on: {
      "click": function($event) {
        _vm.copyValueToInput(_vm.formatPrice(_vm.getReservationCalculations.grandTotal))
      }
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotal)) + " €")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 pb-2"
  }, [_c('label', [_vm._v("Notes")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link.description),
      expression: "link.description"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "disabled": _vm.generatedLink[0],
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.link.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.link, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fs-small mt-1 d-block text-right",
    class: {
      'color-6': (_vm.link.description || '').length > 50
    }
  }, [_vm._v(_vm._s((_vm.link.description || '').length) + "/50")])]), _vm._v(" "), (!_vm.hasEmail) ? _c('div', {
    staticClass: "fs-small color-1 mt-2"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" This booking has no email address.\n                ")]) : _vm._e()]), _vm._v(" "), (this.getReservationCreation && _vm.generatedLink.length != 0) ? _c('div', {
    staticClass: "bg-lighter px-2 py-3 mb-3 mt-1 radius-normal",
    staticStyle: {
      "border": "1px solid rgb(197, 208, 222)",
      "list-style-type": "disc",
      "padding-left": "40px !important"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [(_vm.generatedLink[0].cancelBookingIfNotPaidAfter) ? _c('span', {
    staticClass: "mr-4"
  }, [_c('strong', [_vm._v("Expires:")]), _vm._v(" " + _vm._s(_vm.formatDateDots(_vm.generatedLink[0].cancelBookingIfNotPaidAfter)) + " \n                        "), _c('strong', [_vm._v(" at ")]), _c('span', [_vm._v(_vm._s(_vm.formatTime(_vm.generatedLink[0].cancelBookingIfNotPaidAfter)))])]) : _c('span', {
    staticClass: "mr-4"
  }, [_c('strong', [_vm._v("Expires:")]), _vm._v(" n/a\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mr-2"
  }, [_c('strong', [_vm._v("Notes:")]), _vm._v(" " + _vm._s(_vm.generatedLink[0].description ? _vm.generatedLink[0].description : 'n/a'))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Amount:")]), _vm._v(" " + _vm._s(_vm.formatPrice(_vm.generatedLink[0].value)))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times fs-large light ml-2 pointer",
    on: {
      "click": function($event) {
        return _vm.deleteLink(_vm.generatedLink[0])
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), (!this.getReservationCreation) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel widest",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok widest",
    attrs: {
      "type": "button",
      "disabled": !_vm.link.value || _vm.link.value == 0 || _vm.isValueExceedingDue || !_vm.timeReservationExpires || _vm.isDescriptionExceedingLimit || _vm.isExpirationExceedingLimit || _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [(_vm.isSaving) ? _c('loader', {
    attrs: {
      "size": "small"
    }
  }) : [_vm._v("Save")]], 2)]) : _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel widest",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok widest",
    attrs: {
      "type": "button",
      "disabled": !_vm.link.value || _vm.link.value == 0 || _vm.isValueExceedingDue || !_vm.timeReservationExpires || _vm.isDescriptionExceedingLimit || _vm.isExpirationExceedingLimit || _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [(_vm.isSaving) ? _c('loader', {
    attrs: {
      "size": "small"
    }
  }) : [_vm._v("Save")]], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4da3caed", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da3caed"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationLink.vue
// module id = 2100
// module chunks = 0